import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import CarLicenseList from './components/CarLicenseList'


const { Cell } = ResponsiveGrid;

const CarLicense = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="車牌預約列表"
        breadcrumbs={[
          {
            name: '車牌預約',
          },
          {
            name: '車牌預約列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <CarLicenseList />
    </Cell>
  </ResponsiveGrid>
);

export default CarLicense;
